import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, Heart, Baby, Home, Briefcase, DollarSign, Globe, HelpCircle, Check } from 'lucide-react';
export function EnrollmentPeriods() {
  const situations = [{
    text: 'Te casaste o divorciaste',
    icon: Heart
  }, {
    text: 'Tuviste o adoptaste un bebé',
    icon: Baby
  }, {
    text: 'Cambiaste de estado o ciudad',
    icon: Home
  }, {
    text: 'Perdiste tu trabajo o cobertura',
    icon: Briefcase
  }, {
    text: 'Cambio en tus ingresos familiares',
    icon: DollarSign
  }, {
    text: 'Obtuviste residencia o ciudadanía',
    icon: Globe
  }, {
    text: 'Otras circunstancias especiales',
    icon: HelpCircle,
    isContact: true
  }];
  return <section className="py-10 md:py-24 bg-cream relative" data-id="element-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8 md:mb-12" data-id="element-26">
          <div className="flex justify-center mb-4" data-id="element-27">
            <Calendar className="w-12 h-12 text-navy" data-id="element-28" />
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-6" data-id="element-29">
            ¿CUÁNDO PUEDO INSCRIBIRME?
          </h2>

          <div className="bg-white p-6 rounded-xl border-l-4 border-gold shadow-sm mb-10 text-left" data-id="element-30">
            <p className="text-lg text-gray-700 mb-4" data-id="element-31">
              <strong className="text-navy" data-id="element-32">
                ¡La buena noticia es que NO tienes que esperar!
              </strong>
            </p>
            <p className="text-gray-600 mb-4" data-id="element-33">
              Mucha gente cree que solo puede obtener un seguro durante el
              período de inscripción abierta al final del año. Eso no es
              completamente cierto.
            </p>
            <p className="text-gray-600" data-id="element-34">
              Existen <strong data-id="element-35">Períodos Especiales de Inscripción</strong> que te
              permiten obtener cobertura en cualquier mes del año, si calificas
              por situaciones como:
            </p>
          </div>
        </motion.div>

        <div className="bg-white rounded-2xl shadow-md overflow-hidden border border-gray-100" data-id="element-36">
          <div className="grid grid-cols-12 bg-navy text-white p-4 font-serif font-bold text-lg" data-id="element-37">
            <div className="col-span-8 md:col-span-9" data-id="element-38">Situación de Vida</div>
            <div className="col-span-4 md:col-span-3 text-center" data-id="element-39">
              ¿Puedes Inscribirte Ahora?
            </div>
          </div>

          <div className="divide-y divide-gray-100" data-id="element-40">
            {situations.map((item, index) => {
            const Icon = item.icon;
            return <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.3,
              delay: index * 0.1
            }} className="grid grid-cols-12 p-4 items-center hover:bg-cream transition-colors" data-id="element-41">
                  <div className="col-span-8 md:col-span-9 flex items-center gap-3" data-id="element-42">
                    <div className="bg-cream-dark p-2 rounded-lg text-navy" data-id="element-43">
                      <Icon className="w-5 h-5" data-id="element-44" />
                    </div>
                    <span className="font-medium text-gray-800" data-id="element-45">
                      {item.text}
                    </span>
                  </div>
                  <div className="col-span-4 md:col-span-3 flex justify-center" data-id="element-46">
                    {item.isContact ? <span className="text-sm font-medium text-navy text-center" data-id="element-47">
                        Contáctame y verificamos
                      </span> : <div className="flex items-center gap-1 text-green-600 font-bold bg-green-50 px-3 py-1 rounded-full" data-id="element-48">
                        <Check className="w-4 h-4" data-id="element-49" /> SÍ
                      </div>}
                  </div>
                </motion.div>;
          })}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-10 bg-gold/10 border border-gold/30 rounded-xl p-6 text-center" data-id="element-50">
          <p className="text-navy font-medium text-lg" data-id="element-51">
            <strong className="font-serif text-xl" data-id="element-52">💡 IMPORTANTE:</strong>{' '}
            Contáctame hoy y en menos de 10 minutos te digo exactamente si
            calificas para inscribirte AHORA MISMO — sin importar el mes en que
            estemos.
          </p>
        </motion.div>
      </div>
    </section>;
}